var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackbutton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50844 16.0037L3.7561 12.2514L3.82889 12.1786L3.81 12.1597L11.4307 4.53899C11.8213 4.14846 12.4544 4.14846 12.8449 4.53899C13.2355 4.92951 13.2355 5.56268 12.8449 5.9532L6.56565 12.2325L8.92265 14.5895L12.8839 18.5507C13.2744 18.9412 13.2744 19.5744 12.8839 19.9649C12.4933 20.3554 11.8602 20.3554 11.4696 19.9649L7.50844 16.0037Z",
    fill: "#0E487A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackbutton);
export default __webpack_public_path__ + "static/media/Back button.dce7b25ff3c9f7eac4a3fdecede2b0fb.svg";
export { ForwardRef as ReactComponent };